import React from 'react';
import { compose } from 'ramda';

import { RichText} from '@synergycms_core/components/generic/';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import PoliciesModal from '../../../components/functional/CustomerForm/PoliciesModal';
import ConditionsModal from '../../../components/functional/CustomerForm/ConditionsModal';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';
import { withContent } from '@synergycms_core/components/providers/translateProvider';

const PolicyModalGroup = class PolicyModalGroup extends React.Component {
  static displayName = 'PolicyModalGroup';

  render() {
    const { group, penalties, requiredPrepaymentText } = this.props.config;
    const hiringConditions =  this.props.content.getHasKeyAndContent('_%condiciones contratacion asociados text%_');
    
    switch(group) {
      case 'eurostarshotels':
      case 'exehotels' :
      case 'ikonikhotels' :
      case 'eurostarshotelcompany':
      case 'tandemapartments':
        return (
          <React.Fragment>
            <RichText translate={true} ucFirst={true} text={'_%sí, he leído y acepto la siguiente%_'}/>{' '}
            {/*<RichText translate={true} text={'_%las%_'}/>{' '}*/}
            <label ref={''}>
            <ConditionsModal modalTitle={'_%condiciones generales de contratación%_'} modalText={'_%condiciones contratacion text%_'}/>{' '}
            </label>
            <RichText translate={true} text={'_%y%_'}/>{' '}
            <label ref={''}>
            <PoliciesModal penalties={penalties} requiredPrepaymentText={requiredPrepaymentText}/>{' '}
            </label>
            <InputNotify model={'required_policies'} css={{ valid: null }}/>
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
              <RichText translate={true} ucFirst={true} text={'_%sí, he leído y acepto la siguiente%_'}/>{' '}
              <label ref={''}>
              <ConditionsModal modalTitle={'_%política de privacidad%_'} modalText={'_%condiciones contratacion text%_'}/>{' , '}
              </label>
              <label ref={''}>
              <PoliciesModal penalties={penalties} requiredPrepaymentText={requiredPrepaymentText}/> </label> <RichText translate={true} text={'_%y%_'}/>{' '}
              <RichText translate={true} text={'_%las%_'}/>{' '}
              {hiringConditions ?
                <label ref={''}>
                <ConditionsModal translate={true} modalTitle={'_%condiciones generales de contratación%_'} modalText={'_%condiciones contratacion asociados text%_'}/> 
                </label>:
                <RichText translate={true} text={'_%condiciones generales de contratación%_'}/>
              }
              <InputNotify model={'required_policies'} css={{ valid: null }}/>
          </React.Fragment> 
        );
    }
  }
};

export default compose(
  PropertyManager(['group', 'penalties', 'requiredPrepaymentText']),
  withContent('i18n')
)(PolicyModalGroup);